import React, { FC, ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { setConfirmationComments } from '../../features/offerConfirmation/offerConfirmationSlice';
import withLocalization from '../hoc/withLocalization';
import './Comments.scss';
const Comments: FC<any> = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const { localize } = props;
  const onCommentsChange = (e) => {
    dispatch(setConfirmationComments(e.target.value));
  };
  return (
    <>
      <div className="commentsWrapper">
        <h5 className="confirmationHeader">
          {localize('preview-sales-engine.static-content.copy.Labels.labels#comments')}
        </h5>
        <textarea
          maxLength={55}
          cols={120}
          className="comments"
          rows={3}
          placeholder={localize('preview-sales-engine.static-content.copy.Labels.labels#comment-box-placeholder')}
          onBlur={onCommentsChange}
        ></textarea>
      </div>
    </>
  );
};
export default withLocalization(Comments);
